// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"165":"d3e08212a9a56f0b","2276":"880789cd6ebc0b5d","4374":"c8dd5eddb3030623"}[chunkId] + ".js";
};